
const getters = {
    monitoring: state => state.log.monitoring,
    userjilu: state => state.userCofig.userjilu
  }
  export default getters
  